import React from 'react';
import { arrayOf, shape, string } from 'prop-types';

// Components
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

const Header = props => {
  const { affiliateList, tierPlanName } = props;
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  return (
    <>
      <Box
        borderBottom={`1px solid ${theme.palette.graphic.light}`}
        display="flex"
        justifyContent="space-between"
        marginBottom={2}
        width="100%"
      >
        <Typography sx={{ color: 'primary.dark' }} variant="subtitle1">
          Annual Volume Tier
        </Typography>
        <Typography sx={{ textTransform: 'uppercase' }} variant="h6">
          {tierPlanName}
        </Typography>
      </Box>
      <Typography
        sx={{ color: 'text.primary', marginBottom: theme.spacing(1) }}
        variant={`${mdUp ? 'subtitle1' : 'body1'}`}
      >
        Affiliates
      </Typography>
      <Box display="flex" flexWrap="wrap" mb={3}>
        {affiliateList.map((affiliate, index) => {
          return (
            <Typography key={`${affiliate.nameShort}-${affiliate.dataCompanyId}`} variant="body2">
              {index === affiliateList.length - 1
                ? affiliate.nameShort
                : `${affiliate.nameShort},\u00A0`}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

Header.propTypes = {
  affiliateList: arrayOf(shape({})).isRequired,
  tierPlanName: string,
};

Header.defaultProps = {
  tierPlanName: '',
};

export default Header;
